<template>
  <div class="projet-part">
    <!-- eslint-disable vue/no-v-html -->

    <h2 id="etat">{{ $t("projetPage.mon-annee.etat-des-lieux.titre") }}</h2>
    <b-message
      v-if="
        requiredIfAllFieldsAreEmptyRule == 'required' &&
        validationActivated &&
        projetAnnuel.typeDossier !== 'DOSSIER_RENOUVELLEMENT_LIGHT'
      "
      type="is-danger"
    >
      <span v-html="$t('projetPage.mon-annee.etat-des-lieux.elements-etudies-error')"></span>
    </b-message>
    <h4></h4>
    <!-- Elements etudies with spider lines -->
    <h3>{{ $t("projetPage.mon-annee.etat-des-lieux.titre-elements-etudies") }}</h3>

    <div>
      <div
        class="inputNotice mt-2"
        v-html="$t('projetPage.mon-annee.etat-des-lieux.elements-etudies-doc')"
      ></div>
      <div
        class="inputNotice mt-2"
        v-html="$t('projetPage.mon-annee.etat-des-lieux.elements-etudies-link')"
      ></div>
    </div>

    <div class="spider mt-2">
      <div id="left_circle" class="left_circle">
        <div
          id="circle"
          class="circle"
          v-html="$t('projetPage.mon-annee.etat-des-lieux.circle')"
        ></div>
      </div>
      <!-- eslint-enable vue/no-v-html -->
      <div class="right_questions">
        <InputWithValidation
          ref="etat1"
          v-model="etatDesLieuxContexteAdministratif"
          :validation-activated="validationActivated"
          :show-validation-errors="showValidationErrors"
          :rules="
            projetAnnuel.etatDesLieuxContexteAdministratif
              ? 'required'
              : requiredIfAllFieldsAreEmptyRule
          "
          type="textarea"
          :label="$t('projetPage.mon-annee.etat-des-lieux.administratif-question')"
          :placeholder="$t('projetPage.mon-annee.etat-des-lieux.administratif-input')"
          maxlength="1400"
          :disabled="readonly || !isPorteurProjet"
          :hidden-badge="true"
          vid="etat_administratif"
          @manual-change="dirtifyProject"
        />
        <InputWithValidation
          ref="etat2"
          v-model="etatDesLieuxContextePhysique"
          :validation-activated="validationActivated"
          :show-validation-errors="showValidationErrors"
          :rules="
            projetAnnuel.etatDesLieuxContextePhysique ? 'required' : requiredIfAllFieldsAreEmptyRule
          "
          type="textarea"
          :label="$t('projetPage.mon-annee.etat-des-lieux.physique-question')"
          :placeholder="$t('projetPage.mon-annee.etat-des-lieux.physique-input')"
          maxlength="1400"
          :disabled="readonly || !isPorteurProjet"
          vid="etat_physique"
          @manual-change="dirtifyProject"
        />
        <InputWithValidation
          ref="etat3"
          v-model="etatDesLieuxContexteSocio"
          :validation-activated="validationActivated"
          :show-validation-errors="showValidationErrors"
          :rules="
            projetAnnuel.etatDesLieuxContexteSocio ? 'required' : requiredIfAllFieldsAreEmptyRule
          "
          type="textarea"
          :label="$t('projetPage.mon-annee.etat-des-lieux.socio-question')"
          :placeholder="$t('projetPage.mon-annee.etat-des-lieux.socio-input')"
          maxlength="1400"
          :disabled="readonly || !isPorteurProjet"
          vid="etat_socio"
          @manual-change="dirtifyProject"
        />
        <InputWithValidation
          ref="etat4"
          v-model="etatDesLieuxContextePatrimonial"
          :validation-activated="validationActivated"
          :show-validation-errors="showValidationErrors"
          :rules="
            projetAnnuel.etatDesLieuxContextePatrimonial
              ? 'required'
              : requiredIfAllFieldsAreEmptyRule
          "
          type="textarea"
          :label="$t('projetPage.mon-annee.etat-des-lieux.patrimonial-question')"
          :placeholder="$t('projetPage.mon-annee.etat-des-lieux.patrimonial-input')"
          maxlength="1400"
          :disabled="readonly || !isPorteurProjet"
          vid="etat_patrimonial"
          @manual-change="dirtifyProject"
        />
        <InputWithValidation
          ref="etat5"
          v-model="etatDesLieuxContexteEcoGeo"
          :validation-activated="validationActivated"
          :show-validation-errors="showValidationErrors"
          :rules="
            projetAnnuel.etatDesLieuxContexteEcoGeo ? 'required' : requiredIfAllFieldsAreEmptyRule
          "
          type="textarea"
          :label="$t('projetPage.mon-annee.etat-des-lieux.ecogeo-question')"
          :placeholder="$t('projetPage.mon-annee.etat-des-lieux.ecogeo-input')"
          maxlength="1400"
          :disabled="readonly || !isPorteurProjet"
          vid="etat_ecogeo"
          @manual-change="dirtifyProject"
        />
      </div>
    </div>

    <FileWithValidation
      :label="$t(`projetPage.mon-annee.etat-des-lieux.fichier-titre`)"
      :validation-activated="validationActivated"
      :show-validation-errors="showValidationErrors"
      :placeholder="$t(`projetPage.infoAdministratives.charte.televerser`)"
      :input-notice="$t('projetPage.mon-annee.etat-des-lieux.fichier')"
      :file-operation-url="etatDesLieuxFileUrl"
      :disabled="readonly"
      vid="etat_fichier_single"
      :model-value="projetAnnuel.etatdesLieuxFilePresent"
      default-file-name="ETAT_DES_LIEUX.pdf"
      @add-file="addEtatDesLieuxFile"
      @delete-file="deleteEtatDesLieuxFile"
    />

    <fieldset>
      <legend>{{ $t("projetPage.mon-annee.etat-des-lieux.liens-enseignements-titre") }}</legend>
      <b-message
        v-if="
          validationActivated &&
          (projetAnnuel.typeDossier === 'DOSSIER_LABELLISATION' ||
            projetAnnuel.typeDossier === 'DOSSIER_RENOUVELLEMENT') &&
          showRequiredMessage
        "
        type="is-danger"
      >
        {{ $t("projetPage.mon-annee.autres-infos.labellisation-renouvellement") }}
      </b-message>
      <InputWithValidation
        v-model="etatDesLieuxLiensEnseignements"
        :validation-activated="validationActivated"
        :show-validation-errors="showValidationErrors"
        type="textarea"
        :rules="projetAnnuel.typeDossier === 'DOSSIER_RENOUVELLEMENT_LIGHT' ? '' : calculatedRules"
        :label="$t('projetPage.mon-annee.etat-des-lieux.liens-enseignements')"
        maxlength="1400"
        :disabled="readonly || !isPorteurProjet"
        vid="etat_liens"
        @manual-change="dirtifyProject"
      />
      <FileWithValidation
        :label="$t(`projetPage.mon-annee.etat-des-lieux.fichier-titre`)"
        :validation-activated="validationActivated"
        :show-validation-errors="showValidationErrors"
        :placeholder="$t(`projetPage.infoAdministratives.charte.televerser`)"
        :input-notice="$t('projetPage.mon-annee.etat-des-lieux.liens-enseignements-fichier')"
        :file-operation-url="etatDesLieuxLiensUrl"
        :disabled="readonly"
        vid="etat_fichier_liens"
        :model-value="projetAnnuel.etatdesLieuxLiensFilePresent"
        default-file-name="ETAT_DES_LIEUX_LIENS_ENSEIGNEMENTS.pdf"
        @add-file="addLiensFile"
        @delete-file="deleteLiensFile"
      />
    </fieldset>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import { ProjetAnnuelDTO } from "@/model/bean/GeneratedDTOs"
import InputWithValidation from "@/views/inputs/InputWithValidation.vue"
import FileWithValidation from "@/views/inputs/FileWithValidation.vue"
import { FileService } from "@/services/rest/utils/FileService"
import { BMessage } from "buefy"

export default defineComponent({
  name: "EtatDesLieuxView",
  components: {
    InputWithValidation,
    FileWithValidation,
    BMessage,
  },
  props: {
    projetAnnuel: {
      type: Object as PropType<ProjetAnnuelDTO>,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    isPorteurProjet: {
      type: Boolean,
      default: false,
    },
    validationActivated: {
      type: Boolean,
      default: false,
    },
    showValidationErrors: {
      type: Boolean,
      default: true,
    },
    section: {
      type: String,
      required: true,
    },
    currentWidth: {
      type: Number,
      required: false,
      default: 0,
    },
    currentScrollY: {
      type: Number,
      required: false,
      default: 0,
    },
  },

  emits: ["projet-annuel-updated", "dirtify-project", "trigger-validation"],
  data() {
    return {
      fileService: FileService.INSTANCE,
      requiredIfAllFieldsAreEmptyRule: "required",
      etatDesLieuxFileUrl: "",
      etatDesLieuxLiensUrl: "",
      calculatedRules: "required",
      showRequiredMessage: true,
    }
  },
  computed: {
    // Computed properties pour éviter les mutations de props dans les v-model
    etatDesLieuxContexteAdministratif: {
      get(): string {
        return this.projetAnnuel.etatDesLieuxContexteAdministratif || ""
      },
      set(value: string): void {
        const updatedProjet = { ...this.projetAnnuel }
        updatedProjet.etatDesLieuxContexteAdministratif = value
        this.$emit("projet-annuel-updated", updatedProjet)
      },
    },
    etatDesLieuxContextePhysique: {
      get(): string {
        return this.projetAnnuel.etatDesLieuxContextePhysique || ""
      },
      set(value: string): void {
        const updatedProjet = { ...this.projetAnnuel }
        updatedProjet.etatDesLieuxContextePhysique = value
        this.$emit("projet-annuel-updated", updatedProjet)
      },
    },
    etatDesLieuxContexteSocio: {
      get(): string {
        return this.projetAnnuel.etatDesLieuxContexteSocio || ""
      },
      set(value: string): void {
        const updatedProjet = { ...this.projetAnnuel }
        updatedProjet.etatDesLieuxContexteSocio = value
        this.$emit("projet-annuel-updated", updatedProjet)
      },
    },
    etatDesLieuxContextePatrimonial: {
      get(): string {
        return this.projetAnnuel.etatDesLieuxContextePatrimonial || ""
      },
      set(value: string): void {
        const updatedProjet = { ...this.projetAnnuel }
        updatedProjet.etatDesLieuxContextePatrimonial = value
        this.$emit("projet-annuel-updated", updatedProjet)
      },
    },
    etatDesLieuxContexteEcoGeo: {
      get(): string {
        return this.projetAnnuel.etatDesLieuxContexteEcoGeo || ""
      },
      set(value: string): void {
        const updatedProjet = { ...this.projetAnnuel }
        updatedProjet.etatDesLieuxContexteEcoGeo = value
        this.$emit("projet-annuel-updated", updatedProjet)
      },
    },
    etatDesLieuxLiensEnseignements: {
      get(): string {
        return this.projetAnnuel.etatDesLieuxLiensEnseignements || ""
      },
      set(value: string): void {
        const updatedProjet = { ...this.projetAnnuel }
        updatedProjet.etatDesLieuxLiensEnseignements = value
        this.$emit("projet-annuel-updated", updatedProjet)
      },
    },
  },
  watch: {
    projetAnnuel: {
      handler(): void {
        if (!this.projetAnnuel || !this.projetAnnuel.id) {
          return
        }
        this.etatDesLieuxFileUrl = this.fileService.buildUniqueFileURL(
          this.projetAnnuel.id,
          "ETAT_DES_LIEUX",
        )
        this.etatDesLieuxLiensUrl = this.fileService.buildUniqueFileURL(
          this.projetAnnuel.id,
          "ETAT_DES_LIEUX_LIENS_ENSEIGNEMENTS",
        )
      },
      immediate: true,
    },
    "projetAnnuel.problematiquesLiens": {
      handler(): void {
        this.updateEtatdesLieuxLiensRenseignementRules()
      },
    },
    "projetAnnuel.conseilsLiens": {
      handler(): void {
        this.updateEtatdesLieuxLiensRenseignementRules()
      },
    },
    "projetAnnuel.diffusionLiensEnseignements": {
      handler(): void {
        this.updateEtatdesLieuxLiensRenseignementRules()
      },
    },
    "projetAnnuel.etatDesLieuxLiensEnseignements": {
      handler(): void {
        this.updateEtatdesLieuxLiensRenseignementRules()
      },
    },
    currentScrollY: {
      handler(): void {
        this.drawSpiderLines()
      },
    },
    currentWidth: {
      handler(): void {
        this.drawSpiderLines()
      },
    },
    section: {
      handler(): void {
        if (this.section == "mon-annee") {
          this.$nextTick(this.drawSpiderLines)
        } else {
          this.deleteSVG()
        }
      },
    },
  },
  created(): void {
    if (this.projetAnnuel.id) {
      this.etatDesLieuxFileUrl = this.fileService.buildUniqueFileURL(
        this.projetAnnuel.id,
        "ETAT_DES_LIEUX",
      )
      this.etatDesLieuxLiensUrl = this.fileService.buildUniqueFileURL(
        this.projetAnnuel.id,
        "ETAT_DES_LIEUX_LIENS_ENSEIGNEMENTS",
      )
    }
  },
  mounted(): void {
    // Attendre que le DOM soit complètement rendu et positionné
    this.$nextTick(() => {
      setTimeout(() => {
        this.drawSpiderLines()
        this.setupScrollAndResizeListeners()
      }, 100)
    })
    this.updateEtatdesLieuxLiensRenseignementRules()
    this.recomputedRequiredIfAllFieldsAreEmptyRule()
  },
  unmounted(): void {
    this.deleteSVG()
    this.removeScrollAndResizeListeners()
  },
  methods: {
    setupScrollAndResizeListeners(): void {
      const projectContent = document.getElementById("project-content")
      if (projectContent) {
        projectContent.addEventListener("scroll", this.handleScrollOrResize)
      }
      window.addEventListener("resize", this.handleScrollOrResize)
    },

    removeScrollAndResizeListeners(): void {
      const projectContent = document.getElementById("project-content")
      if (projectContent) {
        projectContent.removeEventListener("scroll", this.handleScrollOrResize)
      }
      window.removeEventListener("resize", this.handleScrollOrResize)
    },

    handleScrollOrResize(): void {
      this.drawSpiderLines()
    },

    dirtifyProject(): void {
      this.recomputedRequiredIfAllFieldsAreEmptyRule()
      this.$emit("dirtify-project")
    },

    addLiensFile(): void {
      // Éviter la mutation directe de props - créer une copie et émettre
      this.updateProjetAnnuelFile("etatdesLieuxLiensFilePresent", true)
    },

    deleteLiensFile(): void {
      // Éviter la mutation directe de props - créer une copie et émettre
      this.updateProjetAnnuelFile("etatdesLieuxLiensFilePresent", false)
    },

    addEtatDesLieuxFile(): void {
      // Éviter la mutation directe de props - créer une copie et émettre
      this.updateProjetAnnuelFile("etatdesLieuxFilePresent", true)
    },

    deleteEtatDesLieuxFile(): void {
      // Éviter la mutation directe de props - créer une copie et émettre
      this.updateProjetAnnuelFile("etatdesLieuxFilePresent", false)
    },

    updateProjetAnnuelFile<K extends keyof ProjetAnnuelDTO>(
      attributeName: K,
      isPresent: ProjetAnnuelDTO[K],
    ): void {
      const updatedProjet = { ...this.projetAnnuel }
      updatedProjet[attributeName] = isPresent
      this.$emit("projet-annuel-updated", updatedProjet)
      this.$emit("trigger-validation")
    },

    recomputedRequiredIfAllFieldsAreEmptyRule(): void {
      // If all fields are empty => required
      if (
        this.projetAnnuel.typeDossier !== "DOSSIER_RENOUVELLEMENT_LIGHT" &&
        !this.projetAnnuel.etatDesLieuxContexteAdministratif &&
        !this.projetAnnuel.etatDesLieuxContextePhysique &&
        !this.projetAnnuel.etatDesLieuxContextePatrimonial &&
        !this.projetAnnuel.etatDesLieuxContexteSocio &&
        !this.projetAnnuel.etatDesLieuxContexteEcoGeo
      ) {
        this.requiredIfAllFieldsAreEmptyRule = "required"
      } else {
        // optionnal otherwise
        this.requiredIfAllFieldsAreEmptyRule = ""
      }
    },

    updateEtatdesLieuxLiensRenseignementRules(): void {
      if (
        !this.projetAnnuel.problematiquesLiens &&
        !this.projetAnnuel.conseilsLiens &&
        !this.projetAnnuel.diffusionLiensEnseignements
      ) {
        this.calculatedRules = "required"
      } else {
        if (this.projetAnnuel.etatDesLieuxLiensEnseignements) {
          this.calculatedRules = "required"
        } else {
          this.calculatedRules = ""
        }
      }

      this.showRequiredMessage = !(
        this.projetAnnuel.problematiquesLiens ||
        this.projetAnnuel.conseilsLiens ||
        this.projetAnnuel.diffusionLiensEnseignements ||
        this.projetAnnuel.etatDesLieuxLiensEnseignements
      )
    },

    drawSpiderLines(): void {
      const existingSVG = document.getElementById("lines-svg")
      if (existingSVG) {
        existingSVG.remove()
      }

      if (this.section == "mon-annee") {
        const strokeColor = "#003976"
        const strokeWidth = "2"
        const circleR = 10

        const spiderContainer = document.querySelector(".spider")
        const startPointEl = document.getElementById("circle")

        let topMostEl: HTMLElement | null = null
        let bottomMostEl: HTMLElement | null = null
        let inputFields: NodeListOf<Element> | null = null

        if (spiderContainer) {
          // Chercher les 5 champs spécifiquement dans .right_questions
          const rightQuestions = spiderContainer.querySelector(".right_questions")

          if (rightQuestions) {
            // Essayer plusieurs stratégies pour trouver les 5 champs
            inputFields = rightQuestions.querySelectorAll(".field.InputWithValidation-field")

            // Si on n'a pas 5 champs, essayer d'autres selectors
            if (inputFields.length < 5) {
              inputFields = rightQuestions.querySelectorAll(".field")
            }

            // Si toujours pas 5, prendre tous les composants InputWithValidation
            if (inputFields.length < 5) {
              inputFields = rightQuestions.querySelectorAll("[vid*='etat_']")
            }

            // En dernier recours, utiliser les refs Vue pour forcer la détection
            if (inputFields.length < 5) {
              const refElements = []
              for (let i = 1; i <= 5; i++) {
                const ref = this.$refs[`etat${i}`] as any
                if (ref && ref.$el) {
                  // Trouver l'élément DOM réel dans le composant
                  const fieldEl =
                    ref.$el.querySelector(".field") ||
                    ref.$el.querySelector(".InputWithValidation-field") ||
                    ref.$el
                  if (fieldEl) {
                    refElements.push(fieldEl)
                  }
                }
              }
              if (refElements.length >= 5) {
                inputFields = refElements as any
              }
            }
          }

          if (inputFields && inputFields.length >= 5) {
            topMostEl = inputFields[0] as HTMLElement
            bottomMostEl = inputFields[4] as HTMLElement
          } else if (inputFields && inputFields.length >= 1) {
            // Au minimum, prendre le premier et dernier élément trouvé
            topMostEl = inputFields[0] as HTMLElement
            bottomMostEl = inputFields[inputFields.length - 1] as HTMLElement
          }
        }

        // @ts-ignore
        if (startPointEl && topMostEl && bottomMostEl && inputFields) {
          const projectContent = document.getElementById("project-content")

          if (!projectContent) {
            console.log("[SpiderLines] project-content not found!")
            return
          }

          const startPoint = this.getOffsetRelativeToContainer(startPointEl, projectContent)
          const topMost = this.getOffsetRelativeToContainer(topMostEl, projectContent)
          const bottomMost = this.getOffsetRelativeToContainer(bottomMostEl, projectContent)

          const height = bottomMost.top + bottomMost.height - topMost.top
          const startPointX = startPoint.left + startPoint.width / 2
          const startPointY = height / 2
          const width = topMost.left - 5 - startPointX

          const leftCircle = document.getElementById("left_circle")
          if (leftCircle) {
            leftCircle.style.height = height + "px"
          }

          // Validation des dimensions
          if (width <= 0 || height <= 0) {
            return
          }

          // Calculer la position visible en tenant compte du scroll actuel
          const scrollTop = projectContent.scrollTop
          const scrollLeft = projectContent.scrollLeft
          const containerRect = projectContent.getBoundingClientRect()

          // Position relative à la viewport visible, en tenant compte du scroll
          const visibleTop = topMost.top - scrollTop
          const visibleLeft = startPointX - scrollLeft

          const svgNS = "http://www.w3.org/2000/svg"
          const svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg")
          svgElement.setAttributeNS(
            "http://www.w3.org/2000/xmlns/",
            "xmlns:xlink",
            "http://www.w3.org/1999/xlink",
          )
          svgElement.setAttribute("id", "lines-svg")
          svgElement.setAttribute("width", width.toString())
          svgElement.setAttribute("height", height.toString())
          svgElement.setAttribute(
            "style",
            "position:fixed; left:" +
              (containerRect.left + visibleLeft) +
              "px; top: " +
              (containerRect.top + visibleTop) +
              "px; pointer-events: none; z-index: 0;",
          )

          // Dessiner exactement 5 lignes pour les 5 champs
          const numberOfFields = Math.min(5, inputFields.length)

          for (let i = 0; i < numberOfFields; i++) {
            const targetPointEl = inputFields[i] as HTMLElement

            if (targetPointEl) {
              const targetPoint = this.getOffsetRelativeToContainer(targetPointEl, projectContent)
              const targetPointY = Math.abs(topMost.top - targetPoint.top) + targetPoint.height / 2

              // Draw line to target point
              const line = document.createElementNS(svgNS, "line")
              line.setAttributeNS(null, "x1", "0")
              line.setAttributeNS(null, "y1", startPointY.toString())
              line.setAttributeNS(null, "x2", (width - circleR).toString())
              line.setAttributeNS(null, "y2", targetPointY.toString())
              line.setAttributeNS(null, "stroke-width", strokeWidth)
              line.setAttributeNS(null, "stroke", strokeColor)

              // Draw circle next to target point
              svgElement.appendChild(line)
              const circle = document.createElementNS(svgNS, "circle")
              circle.setAttributeNS(null, "cx", (width - circleR).toString())
              circle.setAttributeNS(null, "cy", targetPointY.toString())
              circle.setAttributeNS(null, "r", circleR.toString())
              circle.setAttributeNS(null, "fill", strokeColor)
              svgElement.appendChild(circle)
            }
          }

          // Ajouter le SVG une seule fois après la boucle
          // Utiliser body pour le SVG en position:fixed
          document.body.appendChild(svgElement)
        }
      }
    },

    getOffset(el: HTMLElement): any {
      const rect = el.getBoundingClientRect()
      return {
        left: rect.left + window.pageXOffset,
        top: rect.top + window.pageYOffset,
        width: rect.width || el.offsetWidth,
        height: rect.height || el.offsetHeight,
      }
    },

    getOffsetRelativeToContainer(el: HTMLElement, container: HTMLElement): any {
      const rect = el.getBoundingClientRect()
      const containerRect = container.getBoundingClientRect()
      return {
        left: rect.left - containerRect.left + container.scrollLeft,
        top: rect.top - containerRect.top + container.scrollTop,
        width: rect.width || el.offsetWidth,
        height: rect.height || el.offsetHeight,
      }
    },

    deleteSVG(): void {
      const existingSVG = document.getElementById("lines-svg")
      if (existingSVG) {
        existingSVG.remove()
      }
    },
  },
})
</script>

<style lang="scss" scoped>
@import "@/styles/variables";

$circle-width: 150px;
.inputNotice li:before {
  content: "- ";
}

.spider {
  display: flex;

  .left_circle {
    width: 30vw;
    min-width: 1.5 * $circle-width;
    height: 100%;
    display: flex;
    padding-left: 40px;
    align-items: center;
    z-index: 1;

    .circle {
      font-family: $font-family-title;
      background-color: white;
      border: 2px solid $ofb-bleu-1;
      width: $circle-width;
      height: $circle-width;
      padding-top: $circle-width / 2 - 30px;
      text-align: center;
      border-radius: 50%;
      text-transform: uppercase;
      z-index: 1;
      font-size: 20px;
    }
  }

  .right_questions {
    width: 60vw;
  }
}

@media screen and (max-width: 1000px) {
  .spider {
    .left_circle {
      display: none;
    }

    .right_questions {
      width: 90vw;
    }
  }
  #lines-svg {
    display: none;
  }
}
</style>
